// @flow
import { SeaConfigActionTypes } from './constants';

type SeaConfigAction = { type: string, payload: {} | string };

// common success
export const seaConfigApiResponseSuccess = (actionType: string, data: any): SeaConfigAction => ({
    type: SeaConfigActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const seaConfigApiResponseError = (actionType: string, error: string): SeaConfigAction => ({
    type: SeaConfigActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getSeaConfig = (id: string): SeaConfigAction => ({
    type: SeaConfigActionTypes.GET_SEA_CONFIG,
    payload: { id },
});

export const addSeaConfig = (seaConfig:any):SeaConfigAction=>({
    type:SeaConfigActionTypes.ADD_SEA_CONFIG,
    payload:seaConfig
})
export const updateSeaConfig = (seaConfig:any):SeaConfigAction=>({
    type:SeaConfigActionTypes.UPDATE_SEA_CONFIG,
    payload:seaConfig
})
export const deleteSeaConfig = (id:string):SeaConfigAction=>({
    type:SeaConfigActionTypes.DELETE_SEA_CONFIG,
    payload:{id}
})

export const listSeaConfigs = (params:any): SeaConfigAction => ({
    type: SeaConfigActionTypes.LIST_SEA_CONFIGS,
    payload: params,
});

export const setFiltersSeaConfigs = (params:any): SeaConfigAction => ({
    type: SeaConfigActionTypes.SET_FILTER,
    payload: params,
})

export const resetSeaConfigs = (): SeaConfigAction => ({
    type: SeaConfigActionTypes.RESET,
    payload: {},
});

